import "./App.css";
import majakScenarij from "./files/Маяк — Сценарий.pdf"
import mayak from "./files/Mayak.pdf"

import { Route, Routes } from "react-router-dom";

// import ScrollToTop from "./components/ScrollToTop";

import Pageii from "./components/pages/Pageii";
import Page1 from "./components/pages/Page1";
import Page2 from "./components/pages/Page2";
import Page3 from "./components/pages/Page3";
import Page4 from "./components/pages/Page4";
import Page5 from "./components/pages/Page5";
import Page6 from "./components/pages/Page6";
import Page7 from "./components/pages/Page7";
import Page8 from "./components/pages/Page8";
import Page9 from "./components/pages/Page9";
import Page10 from "./components/pages/Page10";
import Page11 from "./components/pages/Page11";
import Page12 from "./components/pages/Page12";
import Page13 from "./components/pages/Page13";
import Page14 from "./components/pages/Page14";
import Page15 from "./components/pages/Page15";
import Page16 from "./components/pages/Page16";
import Page17 from "./components/pages/Page17";
import Page18 from "./components/pages/Page18";
import Page19 from "./components/pages/Page19";
import Page20 from "./components/pages/Page20";
import Page21 from "./components/pages/Page21";
import Page22 from "./components/pages/Page22";
import Page23 from "./components/pages/Page23";
import Page24 from "./components/pages/Page24";
import Page25 from "./components/pages/Page25";
import Page26 from "./components/pages/Page26";
import Page27 from "./components/pages/Page27";
import Page28 from "./components/pages/Page28";
import Page29 from "./components/pages/Page29";
import Page30 from "./components/pages/Page30";
import Page31 from "./components/pages/Page31";
import Page32 from "./components/pages/Page32";
import Page33 from "./components/pages/Page33";
import Page34 from "./components/pages/Page34";
import Page35 from "./components/pages/Page35";
import Page36 from "./components/pages/Page36";
import Page37 from "./components/pages/Page37";
import Page38 from "./components/pages/Page38";
import Page39 from "./components/pages/Page39";
import Page40 from "./components/pages/Page40";
import Page41 from "./components/pages/Page41";
import Page42 from "./components/pages/Page42";
import Page43 from "./components/pages/Page43";
import Page44 from "./components/pages/Page44";
import Page45 from "./components/pages/Page45";
import Page46 from "./components/pages/Page46";
import Page47 from "./components/pages/Page47";
import Page48 from "./components/pages/Page48";
import Page49 from "./components/pages/Page49";
import Page50 from "./components/pages/Page50";
import Page51 from "./components/pages/Page51";
import Page52 from "./components/pages/Page52";
import Page53 from "./components/pages/Page53";
import Page54 from "./components/pages/Page54";
import Page55 from "./components/pages/Page55";
import Page56 from "./components/pages/Page56";
import Page57 from "./components/pages/Page57";
import Page58 from "./components/pages/Page58";
import Page59 from "./components/pages/Page59";
import Page60 from "./components/pages/Page60";
import Page61 from "./components/pages/Page61";
import Page62 from "./components/pages/Page62";
import Page63 from "./components/pages/Page63";
import Page64 from "./components/pages/Page64";
import Page65 from "./components/pages/Page65";
import Page66 from "./components/pages/Page66";
import Page67 from "./components/pages/Page67";
import Page68 from "./components/pages/Page68";
import Page69 from "./components/pages/Page69";
import Page70 from "./components/pages/Page70";
import Page71 from "./components/pages/Page71";
import Page72 from "./components/pages/Page72";
import Page73 from "./components/pages/Page73";
import Page74 from "./components/pages/Page74";
import Page75 from "./components/pages/Page75";
import Page76 from "./components/pages/Page76";
import Page77 from "./components/pages/Page77";
import Page78 from "./components/pages/Page78";
import Page79 from "./components/pages/Page79";
import Page80 from "./components/pages/Page80";
import Page81 from "./components/pages/Page81";
import Page82 from "./components/pages/Page82";
import Page83 from "./components/pages/Page83";
import Page84 from "./components/pages/Page84";
import Page85 from "./components/pages/Page85";
import Page86 from "./components/pages/Page86";
import Page87 from "./components/pages/Page87";
import Page88 from "./components/pages/Page88";
import Page89 from "./components/pages/Page89";
import Page90 from "./components/pages/Page90";
import Page91 from "./components/pages/Page91";
import Page92 from "./components/pages/Page92";
import Page93 from "./components/pages/Page93";
import Page94 from "./components/pages/Page94";
import Page95 from "./components/pages/Page95";
import Page96 from "./components/pages/Page96";
import Page97 from "./components/pages/Page97";
import Page98 from "./components/pages/Page98";

function App() {

  return (
    <div className="App">
      <div className="Container">
        <header className="Title">
          <h3>T H E</h3>
          <h1>L  I  G  H  T  H  O  U  S  E</h1>
          <p>сценарий</p>
          <p>Роберт Эггерс</p>
          <p>Макс Эггерс</p>
        </header>

        <Routes>
          <Route exact path="/" element={<Pageii />} />
          <Route exact path="/page1" element={<Page1 />} />
          <Route exact path="/page2" element={<Page2 />} />
          <Route exact path="/page3" element={<Page3 />} />
          <Route exact path="/page4" element={<Page4 />} />
          <Route exact path="/page5" element={<Page5 />} />
          <Route exact path="/page6" element={<Page6 />} />
          <Route exact path="/page7" element={<Page7 />} />
          <Route exact path="/page8" element={<Page8 />} />
          <Route exact path="/page9" element={<Page9 />} />
          <Route exact path="/page10" element={<Page10 />} />
          <Route exact path="/page11" element={<Page11 />} />
          <Route exact path="/page12" element={<Page12 />} />
          <Route exact path="/page13" element={<Page13 />} />
          <Route exact path="/page14" element={<Page14 />} />
          <Route exact path="/page15" element={<Page15 />} />
          <Route exact path="/page16" element={<Page16 />} />
          <Route exact path="/page17" element={<Page17 />} />
          <Route exact path="/page18" element={<Page18 />} />
          <Route exact path="/page19" element={<Page19 />} />
          <Route exact path="/page20" element={<Page20 />} />
          <Route exact path="/page21" element={<Page21 />} />
          <Route exact path="/page22" element={<Page22 />} />
          <Route exact path="/page23" element={<Page23 />} />
          <Route exact path="/page24" element={<Page24 />} />
          <Route exact path="/page25" element={<Page25 />} />
          <Route exact path="/page26" element={<Page26 />} />
          <Route exact path="/page27" element={<Page27 />} />
          <Route exact path="/page28" element={<Page28 />} />
          <Route exact path="/page29" element={<Page29 />} />
          <Route exact path="/page30" element={<Page30 />} />
          <Route exact path="/page31" element={<Page31 />} />
          <Route exact path="/page32" element={<Page32 />} />
          <Route exact path="/page33" element={<Page33 />} />
          <Route exact path="/page34" element={<Page34 />} />
          <Route exact path="/page35" element={<Page35 />} />
          <Route exact path="/page36" element={<Page36 />} />
          <Route exact path="/page37" element={<Page37 />} />
          <Route exact path="/page38" element={<Page38 />} />
          <Route exact path="/page39" element={<Page39 />} />
          <Route exact path="/page40" element={<Page40 />} />
          <Route exact path="/page41" element={<Page41 />} />
          <Route exact path="/page42" element={<Page42 />} />
          <Route exact path="/page43" element={<Page43 />} />
          <Route exact path="/page44" element={<Page44 />} />
          <Route exact path="/page45" element={<Page45 />} />
          <Route exact path="/page46" element={<Page46 />} />
          <Route exact path="/page47" element={<Page47 />} />
          <Route exact path="/page48" element={<Page48 />} />
          <Route exact path="/page49" element={<Page49 />} />
          <Route exact path="/page50" element={<Page50 />} />
          <Route exact path="/page51" element={<Page51 />} />
          <Route exact path="/page52" element={<Page52 />} />
          <Route exact path="/page53" element={<Page53 />} />
          <Route exact path="/page54" element={<Page54 />} />
          <Route exact path="/page55" element={<Page55 />} />
          <Route exact path="/page56" element={<Page56 />} />
          <Route exact path="/page57" element={<Page57 />} />
          <Route exact path="/page58" element={<Page58 />} />
          <Route exact path="/page59" element={<Page59 />} />
          <Route exact path="/page60" element={<Page60 />} />
          <Route exact path="/page61" element={<Page61 />} />
          <Route exact path="/page62" element={<Page62 />} />
          <Route exact path="/page63" element={<Page63 />} />
          <Route exact path="/page64" element={<Page64 />} />
          <Route exact path="/page65" element={<Page65 />} />
          <Route exact path="/page66" element={<Page66 />} />
          <Route exact path="/page67" element={<Page67 />} />
          <Route exact path="/page68" element={<Page68 />} />
          <Route exact path="/page69" element={<Page69 />} />
          <Route exact path="/page70" element={<Page70 />} />
          <Route exact path="/page71" element={<Page71 />} />
          <Route exact path="/page72" element={<Page72 />} />
          <Route exact path="/page73" element={<Page73 />} />
          <Route exact path="/page74" element={<Page74 />} />
          <Route exact path="/page75" element={<Page75 />} />
          <Route exact path="/page76" element={<Page76 />} />
          <Route exact path="/page77" element={<Page77 />} />
          <Route exact path="/page78" element={<Page78 />} />
          <Route exact path="/page79" element={<Page79 />} />
          <Route exact path="/page80" element={<Page80 />} />
          <Route exact path="/page81" element={<Page81 />} />
          <Route exact path="/page82" element={<Page82 />} />
          <Route exact path="/page83" element={<Page83 />} />
          <Route exact path="/page84" element={<Page84 />} />
          <Route exact path="/page85" element={<Page85 />} />
          <Route exact path="/page86" element={<Page86 />} />
          <Route exact path="/page87" element={<Page87 />} />
          <Route exact path="/page88" element={<Page88 />} />
          <Route exact path="/page89" element={<Page89 />} />
          <Route exact path="/page90" element={<Page90 />} />
          <Route exact path="/page91" element={<Page91 />} />
          <Route exact path="/page92" element={<Page92 />} />
          <Route exact path="/page93" element={<Page93 />} />
          <Route exact path="/page94" element={<Page94 />} />
          <Route exact path="/page95" element={<Page95 />} />
          <Route exact path="/page96" element={<Page96 />} />
          <Route exact path="/page97" element={<Page97 />} />
          <Route exact path="/page98" element={<Page98 />} />
        </Routes>
      </div>
      <footer>
        <a className="Logo-link" target="_blank" rel="noreferrer" href="https://www.flamingmachine.ru">
          <div className="Logo-wrapper">
            <div className="Logo" />
          </div>
        </a>
        <ul className="Footer-links">
          <li>
            <a href={majakScenarij} download>PDF версия</a>
          </li>
          <li>
            <a href={mayak} download>PDF на английском</a>
          </li>
        </ul>
      </footer>
      {/* <ScrollToTop /> */}
    </div>
  );
}

export default App;
